import { KoobStateEnum } from '../../utils';
import { KoobConfirmationModal } from '@koob/ui';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { useApp, useLanguage, useResetTripDesigner } from '../../hooks';
import { useAsync } from 'react-async';
import { getRequestAccess } from '../../api/toRequestAccess';
import { useTripFilters, useShouldWarnBeforeExit } from '@koob/trip-designer';
import KoobNavbarCurrentTrip from './KoobNavbarCurrentTrip';
import KoobNavbarDesignTripButton from './KoobNavbarDesignTripButton';

// KD-3970: the app header outside the Trip Designer. No open trip: "Design a
// trip" (dimmed without a client folder). An open trip: the current trip pill
// and its close button — one trip at a time, so no "Design a trip" then.
export default function KoobNavbarTripDesigner() {
  const { t } = useTranslation('tripDesigner');
  const navigate = useNavigate();
  const location = useLocation();
  const { setLang } = useLanguage();
  const { currentUserLang } = useApp();
  const tripFilters = useTripFilters();
  const resetContext = useResetTripDesigner();
  const hasUnsavedChanges = useShouldWarnBeforeExit();
  const [exitConfirmOpen, setExitConfirmOpen] = useState(false);

  const exit = () => {
    resetContext();
    setLang(currentUserLang);
  };

  const { data } = useAsync({
    promiseFn: getRequestAccess,
  });
  const requestAccess = data?.data;

  // KD-3391: on the compose page these controls live in the page header
  // (ComposeHeader), not in the navbar.
  if (location.pathname.includes('/trip-designer/compose')) {
    return null;
  }

  if (requestAccess?.tripDesignerRequestState !== KoobStateEnum.VALIDATED) {
    return null;
  }

  if (tripFilters === null || Object.keys(tripFilters)?.length === 1) {
    return <KoobNavbarDesignTripButton />;
  }

  return (
    <>
      <KoobNavbarCurrentTrip
        showPrice={
          !['/experiences/checkout', '/booking'].includes(location.pathname)
        }
        onResume={() => navigate('/trip-designer/compose')}
        onClose={() => (hasUnsavedChanges ? setExitConfirmOpen(true) : exit())}
      />

      {/* KD-3656: exiting drops what was not saved as draft. */}
      <KoobConfirmationModal
        open={exitConfirmOpen}
        setOpen={setExitConfirmOpen}
        title={t('compose.exitUnsaved.title')}
        description={t('compose.exitUnsaved.description')}
        cancelLabel={t('compose.exitUnsaved.stay')}
        confirmLabel={t('compose.exitUnsaved.confirm')}
        onConfirm={exit}
        danger
      />
    </>
  );
}
